import { render } from "./PregnancyRegistrationModal.vue?vue&type=template&id=2b042326&scoped=true"
import script from "./PregnancyRegistrationModal.vue?vue&type=script&lang=js"
export * from "./PregnancyRegistrationModal.vue?vue&type=script&lang=js"

import "./PregnancyRegistrationModal.vue?vue&type=style&index=0&id=2b042326&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b042326"]])

export default __exports__